import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import {Element} from "react-scroll";

const Summary: React.FC<{ data?: string, content?: Record<string, (string|boolean)[]>, defaultTemplate?: boolean }> = ({ data, content, defaultTemplate }) => {
    return (
        <Element name="summary">
            <div className={"div-section"} style={{marginTop: '48px'}}>
                <div style={{height: '40px'}}>
                    <span className="title-section">
                        {  content?.TITLE?.[0] ? typeof content?.TITLE?.[0] != 'boolean' ? content?.TITLE?.[0] : '総括' : '総括'}
                    </span>
                </div>

                <div className={"border-title"}>
                    <div className={"underline-title-summary"}></div>
                </div>

                <div style={{fontSize: '16px'}}>
                    <div className="pt-4">
                        <div>
                        <span style={{whiteSpace: 'break-spaces' }}>
                            {
                                content?.TEXT?.[0]
                            }
                        </span>
                        </div>
                    </div>
                    {
                        (content?.FEEDBACK?.[0] || defaultTemplate) &&
                        <div className="pb-3 pt-3">
                            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                                {data}
                            </ReactMarkdown>
                        </div>
                    }
                </div>
            </div>
        </Element>
    );
}

export default Summary;
